module.exports = __webpack_public_path__ + "img/vplfl6_fantastic_league_football.dde1857a.png";